<style lang="less" scoped>
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.ant-layout {
  display: flex;
  width: 100%;
  min-height: 100%;
}

.layout {
  height: 100%;
  // padding-top: 80px;
  font-family: @font-name-song;
  margin: 0vw 0vw;
  padding-bottom: 0vw;
}

.logo {
  display: inline-block;

  .img {
    // height: 60px;
    width: 112px;
  }
}

.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  // line-height: 80px;
  padding: 0 50px;
  background-color: @primary-color;
  // min-width: @min-width;
  z-index: 9999;
  display: flex;
  justify-content: space-between;

  .logo {
    display: flex;
    align-items: center;

    .header-title {
      color: var(--White-100, #FFF);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px; /* 133.333% */
      white-space: nowrap;
    }
    .img{
      //width: 112px;
      height: 48px;
      object-fit: contain;
    }
  }
}

.content {
  height: 100%;
  padding: 14px 16px;
  // overflow-y: auto;
}

.header-right {
  //float: right;
  height: 100%;
  line-height: normal;
  padding: 10px;
  display: flex;
  width: 100%;
}

.avatar {
  line-height: normal;
  cursor: pointer;
}

.user-container {
  display: inline-block;
  line-height: normal;
  position: relative;
  top: 0px;
  display: flex;
  margin: auto;

  & > * {
    vertical-align: middle;
  }

  .username {
    padding-left: 4px;
    font-size: 14px;
    min-width: 75px;
    max-width: 120px;
    height: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #FFFFFF;
    text-align: center;
    margin: auto 0px auto 5px;
  }

}

.dropdown-icon {
  margin: 8px auto 8px 8px;
  font-size: 20px;
  color: white;
}

.nav {
  display: inline-block;
  list-style: none;
  margin: 0 auto 0 auto;
  padding: 0;
  //margin-right: 40px;
  width: 100%;
  text-align: center;
}

.nav-btn {
  display: inline-block;
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: @border-radius-base;
  font-size: 18px;
  text-align: center;
  color: white;
  transition: all 0.2s;
  cursor: pointer;
  margin-left: 24px;

  a {
    display: inline-block;
    height: 100%;
    width: 100%;
    color: rgba(255, 255, 255, 0.8);
    transition: color 0.2s;
  }
}

.nav-btn.active,
.nav-btn:hover {
  // background-color: @white;
  color: @white;

  a {
    color: @white;
  }
}

.content {
  margin: 0;
  padding: 0;
}

/* 页面容器：宽度限制 + 根据窗口宽度的响应式 padding */
.page-container {
  min-width: 1024px;
  max-width: 1680px;
  margin: 0 auto;
  box-sizing: border-box;
}
@media (min-width: 1441px) {
  .page-container {
    padding: 20px 80px;
  }
}
@media (min-width: 1200px) and (max-width: 1440px) {
  .page-container {
    padding: 20px 32px;
  }
}
@media (max-width: 1199px) {
  .page-container {
    padding:20px 24px;
  }
}

.activeBorder {
  width: 48px;
  border-bottom: 2px solid white;
  border-radius: 2px;
  margin: 0px auto;
}

.titleUl {
  height: 60px;
  //line-height: 60px;
  // display: flex;
  width: 100%;

  .titleLi {
    display: inline-block;
    font-size: 20px;
    font-weight: 400;
    color: #fff;
    font-style: normal;
    // width: 120px;
    padding: 0 8px;
    height: 60px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    position: relative;

    &:hover {
      color: #fff;
      font-weight: 600;
      opacity: 1;

      .secTitle {
        position: absolute;
        display: block;
        top: 56px;
        left: 0px;
        width: 120px;
        // height: 80px;
        background: rgba(0, 0, 0, 0.5);
        text-align: center;
        font-size: 18px;
        color: #fff;
        z-index: 99999999;

        .secLi {
          height: 40px;
          line-height: 40px;
          width: 120px;

          &:hover {
            background-color: @primary-color;
            color: #fff;
          }
        }
      }

      .secTitle::before {
        content: "";
        position: absolute;
        top: -20px;
        left: 50%;
        border-width: 10px;
        border-style: solid;
        border-color: transparent transparent rgba(0, 0, 0, 0.5) transparent;
        transform: translateX(-50%);
      }
    }

    .secTitle {
      position: absolute;
      display: none;
      top: 60px;
      left: 0;
      z-index: 999999;
    }
  }
}

.activeLi {
  color: #fff;
  opacity: 1;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  display: inline-block;
  // width: 100px;
  padding: 0 8px;
  text-align: center;
  position: relative;
  cursor: pointer;

  &::after {
    width: 50px;
    height: 2px;
    content: '';
    position: absolute;
    top: 90%;
    left: 25%;
    background-color: #fff;
    color: #fff;
  }
}

.logout {
  text-align: center;
  height: 40px;
  line-height: 40px;
  padding: 0px 20px;
}

.radio {
  display: block;
  height: 30px;
  lineHeight: 30px;
  margin-left: 130px;
}

.f-del {
  display: flex;
  width: 180px;
  margin: 20px auto 0;

  .f-c {
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #DBD1CD;
    color: #867D7B;
    height: 30px;
    text-align: center;
    width: 70px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 30px;
    text-align: center;
    margin: auto;
    cursor: pointer;
  }

  .f-s {
    background: @primary-color;
    color: #fff;
    border-radius: 4px;
    height: 30px;
    text-align: center;
    width: 70px;
    line-height: 30px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: center;
    margin: auto;
    cursor: pointer;
  }
}

* {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {
  // transform: translateX(30px);
  opacity: 0;
}
</style>

<template>
  <div class="layout" :style="{background:'#f6f6f6'}">
    <a-layout>
      <a-layout-header :class="{ color: 'color' }" :style='style'>
        <div class="header">
          <div class="logo">
            <svg class="img" aria-hidden="true">
              <use :xlink:href="layoutLogoHref" />
            </svg>
            <div class="header-title">高阶华文融媒体智能学习系统</div>
          </div>
          <div class="header-right">
            <div class="nav">
              <ul class="titleUl" mode="horizontal">
                <li class="titleLi" v-for="(item,index) in titleList" :key="index"
                    @click.capture=changeTitle1(item,index)>
                  <transition name='slide-fade'>
                    <div :class="current == index?'activeLi':'titleLi'">
                      {{ item.name || '' }}
                      <ul v-if="item.list" class="secTitle">
                        <li class="secLi" v-for="i in item.list" :key="i.key" @click="changePage(i)">
                          {{ i.name || '' }}
                        </li>
                      </ul>
                    </div>
                  </transition>
                </li>
              </ul>
            </div>
            <a-dropdown placement="bottomRight" class="user">
              <div class="user-container">
                <img style="width:40px;height:40px;border-radius: 50%; object-fit: cover;"
                     :src="$store.getters.userPhoto&&$store.getters.userPhoto!=null?$store.getters.userPhoto:mrPhoto"
                     alt="">
                <!-- <myUser group="avatar" :avatar="shareData.userPhoto?shareData.userPhoto:(user.photo&&user.photo!=null?user.photo:mrPhoto)" :username="user.name || user.username || ''"
              :size="48" /> -->
                <a-tooltip placement="left" >
                  <template #title>{{ $store.getters.userInfo.name || ''}} </template>
                    <span class="username"> {{ $store.getters.userInfo.name || ''}}</span>
                </a-tooltip>
                <a-icon type="caret-down" class="dropdown-icon"/>
              </div>
              <a-menu style="margin-top:10px;" slot="overlay" @click="handleDropdownMenuClick">
                <a-menu-item class="logout" key="choice" v-show="roleChoiceVis">切换角色</a-menu-item>
                <a-menu-item class="logout" key="logout">退出登录</a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
      </a-layout-header>
      <a-layout-content :style="{ marginTop: '64px',background:'#f6f6f6' }" class="layout-content">
        <Move   v-if="roleList && roleList.length > 1"/>
        <div class="page-container">
          <transition name='slide-fade'>
            <router-view></router-view>
          </transition>
        </div>
      </a-layout-content>
    </a-layout>

    <!-- 角色选择-->
    <a-modal title="选择角色" width="400px" @cancel="classNoticeVis = false" :visible="classNoticeVis" footer="">
      <template>
        <div>
          <a-radio-group v-model="value" @change="onChange">
            <a-radio class="radio" :value="1">教师角色</a-radio>
            <a-radio class="radio" :value="2">学生角色</a-radio>
          </a-radio-group>
        </div>
        <div class="f-del">
          <div class="f-c" @click="() => { this.classNoticeVis = false;}">取消</div>
          <div class="f-s" @click="classNoticeOk">确认</div>
        </div>
      </template>
    </a-modal>
    <!-- <div group="content">
      <router-view />
    </div> -->
  </div>
</template>

<script>
import { mainRoutes } from '../router'
import Move from '@/components/Move.vue'
// import logo from '../assets/logo.svg'
// import brand from '../assets/brand.svg'
// import myUser from 'components/User.vue'
import { clearUserInfo } from './Login.vue'
import shareState from 'utils/shareState.js'
import layoutLogoSvg from '@/assets/imgs/login/layout-logo.svg'

const layoutLogoHref = `#${(layoutLogoSvg && layoutLogoSvg.id) ? layoutLogoSvg.id : layoutLogoSvg}`

export default {
  name: 'layout',
  components: { Move },
  data () {
    return {
      shareData: shareState.state,
      roleList: this.$getUserInfo().roleList,
      menu: mainRoutes,
      activeMenuItem: 'Books',
      user: {},
      collapsed: false,
      loading: false,
      classNoticeVis: false,
      value: 1,
      roleValue: 1,
      noReadmsgNum: 0,
      titleList: [
        { name: '首页', key: 'HomePage', id: 0 },
        { name: '在线备课', key: 'Books', id: 1 },
        // { name: '陪伴助学', key: 'AccompanyStudy', id: 2 },
        { name: '班级管理', key: 'Class', id: 6 },
        {
          name: '名师之路',
          key: 'newSnailLive',
          id: 3,
          list: [
            { name: '蜗牛视频', key: 'newSnailLive', id: 31 },
            // { name: '蜗牛视频', key: 'snailVideoList', id: 32 },
            { name: '蜗牛文章', key: 'snailBookList', id: 33 },
            { name: '互动空间', key: 'chatRoom', id: 34 }
            // {name: '测试', key: 'SnailVideo',id: 45},
          ]
        },
        { name: '高考真题', key: 'GaokaoRealExam', id: 8 },
        { name: '个人中心', key: 'PersonalCenter', id: 4 }
        // { name: 'APP下载', key: 'Download', id: 5 },
      ],
      current: 0,
      style: {
        position: 'fixed',
        width: '100%',
        background: '#fff',
        borderBottom: 'none',
        boxShadow: '',
        zIndex: '99'
      },
      color: false,
      roleChoiceVis: false,
      mrPhoto: require('../assets/imgs/teacher.png'),
      layoutLogoHref
    }
  },
  computed: {
    userPhoto: {
      get () {
        return JSON.parse(localStorage.getItem('user_info')).photo
      }
    }
  },
  watch: {
    $route (to) {
      console.log('$route', this.$getUserInfo())
      const userInfo = this.$getUserInfo()
      this.user = userInfo
      const navIdx = this.titleList.findIndex((t) => t.key === to.name)
      if (navIdx >= 0) {
        this.current = navIdx
        sessionStorage.setItem('routeIndex', String(navIdx))
      } else {
        this.routeKsy = sessionStorage.getItem('routeIndex')
        if (this.routeKsy !== null && this.routeKsy !== '') {
          this.current = Number(this.routeKsy)
        } else {
          this.current = 0
        }
      }
    }
  },
  methods: {
    changeTitle1 (item, index) {
      this.current = index
      sessionStorage.setItem('routeIndex', index)
      this.$router.push({ name: item.key })
      this.$forceUpdate()
    },
    changePage (i) {
      this.$router.push({ name: i.key })
    },
    shouldMatch () {
      this.activeMenuItem = this.$route.matched[1].name || 'Books'
    },
    /** ant-design-vue Menu 的 @click 传入 { key, keyPath, item, domEvent }，勿用 DOM 的 click 事件 */
    handleDropdownMenuClick ({ key }) {
      sessionStorage.setItem('homeRoledialog', '0')
      if (key === 'choice') {
        this.handleRoleChioce()
      } else if (key === 'logout') {
        this.logout()
      }
    },
    handleRoleChioce () {
      const roleList = this.$getUserInfo().roleList
      if (roleList && roleList.length > 0) {
        // 显示角色弹窗
        this.classNoticeVis = true
      } else {

      }
    },
    showRoleChoice () {
      // const roleList = this.$getUserInfo().roleList
      // // 判断数组中是否同时包含teacher和student
      // if (roleList && roleList.some(item => item.roleName === 'ROLE_TEACHER_ENT') && roleList.some(item => item.roleName === 'ROLE_LEARNER_ENT')) {
      //   // 如果同时包含teacher和student，则弹出提示框
      //   this.roleChoiceVis = true
      // }
    },
    onChange (e) {
      console.log('radio checked', e.target.value)
      this.roleValue = e.target.value
    },
    classNoticeOk () {
      this.classNoticeVis = false
      if (this.roleValue === 1) {
        // 教师角色
      } else {
        if (this.$loginStudentUrl) window.location.replace(this.$loginStudentUrl)
      }
    },
    gotoStudentClient () {
      if (this.$loginStudentUrl) window.location.replace(this.$loginStudentUrl)
    },
    logout () {
      clearUserInfo()
      sessionStorage.clear()
      localStorage.clear()
      if (this.$loginUrl) window.location.replace(this.$loginUrl)
    }
  },
  mounted () {
    const userInfo = this.$getUserInfo()
    this.user = userInfo
    userInfo && (this.user = userInfo)
    const userPhoto = userInfo && userInfo.photo && userInfo.photo != null ? this.$userINfoBasePath + '/' + userInfo.photo : ''
    this.$store.commit('setUserPhoto', userPhoto)
    const navIdx = this.titleList.findIndex((t) => t.key === this.$route.name)
    if (navIdx >= 0) {
      this.current = navIdx
      sessionStorage.setItem('routeIndex', String(navIdx))
    } else {
      this.routeKsy = sessionStorage.getItem('routeIndex')
      if (this.routeKsy !== null && this.routeKsy !== '') {
        this.current = Number(this.routeKsy)
      } else {
        this.current = 0
      }
    }
    this.showRoleChoice()
  }
}
</script>
